import { Layout, Page } from "@shopify/polaris";
import { useState, useEffect } from "react";
import * as FullStory from "@fullstory/browser";

import Account from "./components/Account";
import NewAccount from "./components/NewAccount";
import psClient from "./utils/psClient";
import AppContext from "./components/AppContext";
import Footer from "./components/Footer";
import CenteredSpinner from "./components/CenteredSpinner";

const Home = ({ sessionReady }) => {
  const [completedOnboarding, setCompletedOnboarding] = useState(false);
  const [userId, setUserId] = useState();
  const [shopId, setShopId] = useState();
  const [shop, setShop] = useState();
  const [loading, setLoading] = useState(true);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const userSettings = {
    userId,
    shopId,
    shop,
  };

  useEffect(() => {
    if (!sessionReady) return;

    (async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams(window.location.search);
        const shop = params.get("shop");

        if (shop) {
          setShop(shop);
        }

        FullStory.identify(shop, {
          shopifyDomain: shop,
          SCAVersion: 2,
        });

        const accountResult = await psClient.get("/v2/sales-channel/account");

        if (!accountResult) {
          return;
        }

        if (accountResult.completed_onboarding) {
          setCompletedOnboarding(true);
        }
        if (accountResult.user_id) {
          setUserId(accountResult.user_id);
        }
        if (accountResult.shop_id) {
          setShopId(accountResult.shop_id);

          FullStory.setUserVars({
            shopId: accountResult.shop_id,
          });
        }
      } catch (err) {
        // If we threw an unhandled error here it would prevent the user from logging in, instead we log and continue
        console.log(err);
      }

      setLoading(false);
    })();
  }, [sessionReady]);

  if (loading) {
    return <CenteredSpinner />;
  }

  return (
    <AppContext.Provider value={userSettings}>
      <Page>
        <Layout>{completedOnboarding ? <Account /> : <NewAccount />}</Layout>
      </Page>
      <Footer />
    </AppContext.Provider>
  );
};

export default Home;
